import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if (!localStorage.hideDFPlannedMaintenanceMessage) {
    $('.planned-maintenance').css('visibility', 'visible');
  } else {
    $('.planned-maintenance').remove();
  }

  $(document).on('click', '.planned-maintenance__close', (e) => {
    localStorage.hideDFPlannedMaintenanceMessage = true;
    $(e.target).closest('.planned-maintenance').remove();
  });
});
